/* eslint-disable @typescript-eslint/indent */
import { validateOnCompletedAndOnErrorOptions } from '@netfront/common-library';

import { ADD_UNIT_MUTATION } from './useAddUnit.graphql';
import {
  IAddUnitMutationGraphQLResponse,
  IAddUnitMutationVariables,
  IHandleAddUnitParams,
  IUseAddUnitOptions,
  IUseAddUnit,
} from './useAddUnit.interfaces';
import { useLoggedGeladaMutation } from '@netfront/gelada-identity-library';

const useAddUnit = (options?: IUseAddUnitOptions): IUseAddUnit => {
  const { mutation, onCompleted, onCompletedAsync, onError, onErrorAsync, product, tokens } = options ?? {};

  validateOnCompletedAndOnErrorOptions({
    onCompleted,
    onCompletedAsync,
    onError,
    onErrorAsync,
  });

  const [executeAddUnits, { loading: isLoading }] = useLoggedGeladaMutation<
  IAddUnitMutationGraphQLResponse,
  IAddUnitMutationVariables
  >({
    mutation: mutation ?? ADD_UNIT_MUTATION,
    options: {
      onCompleted: ({ unit: { add: unit } }) => {
        if (onCompleted) {
          onCompleted({
            unit,
          });
        }
      },
      onError: (error) => {
        if (onError) {
          onError(error);
        }

        if (onErrorAsync) {
          void onErrorAsync(error);
        }
      },
    },
    product,
    tokens,
  });

  const handleAddUnit = async ({
    groupId,
    unitName
  }: IHandleAddUnitParams) => {
    await executeAddUnits({
      variables: {
        groupId,
        unitName
      },
    });
  };

  return {
    handleAddUnit,
    isLoading,
  };
};

export { useAddUnit };
